export default "__VITE_ASSET__BT_Gt7fR__"